<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<mat-card appearance="raised">
  <mat-card-header>
    <mat-card-title>
      <span class="mdi mdi-file-document-outline title-icon"></span>{{'FILE' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="data-title">{{'ALC_ALWAYS' | translate}}</div>
    <div class="file-section-wrapper">
      <div class="header-row">
        <span class="header-col">{{'data-protections.protection-type' | translate}}</span>
        <span class="header-col">{{'VALUE' | translate}}</span>
      </div>
      <div class="data-row">
        <span class="data-col data-values">{{'FILE_TYPE' | translate}}</span>
        <span *ngIf="lockedExtensions.length > 0; else noLockedExtensions" class="data-col data-values">{{ lockedExtensions.join(', ') }}</span>
        <ng-template #noLockedExtensions>
          <span class="data-col data-values">({{'NONE' | translate}})</span>
          <span></span>
        </ng-template>
        <span *ngIf="lockedExtensions.length > 0" id="copyLockedExtensionsButton" class="mdi mdi-content-copy clickable copy-icon"
          matTooltip="{{'data-protections.copy-text-tooltip' | translate}}" matTooltipPosition="above"
          (click)="onCopyText(lockedExtensions.join(','))">
        </span>
      </div>
      <div class="data-row">
        <span class="data-col data-values">{{'FOLDER' | translate}}</span>
        <span *ngIf="lockedFolders.length > 0; else noLockedFolders" class="data-col data-values">{{ lockedFolders.join(', ') }}</span>
        <ng-template #noLockedFolders>
          <span class="data-col data-values">({{'NONE' | translate}})</span>
          <span></span>
        </ng-template>
        <span *ngIf="lockedFolders.length > 0" id="copyLockedFoldersButton" class="mdi mdi-content-copy clickable copy-icon"
          matTooltip="{{'data-protections.copy-text-tooltip' | translate}}" matTooltipPosition="above"
          (click)="onCopyText(lockedFolders.join(','))">
        </span>
      </div>
    </div>

    <div class="data-title">{{'data-protections.during-threats' | translate}}</div>
    <div class="file-section-wrapper">
      <div class="header-row">
        <span class="header-col">{{'data-protections.protection-type' | translate}}</span>
        <span class="header-col">{{'VALUE' | translate}}</span>
      </div>
      <div class="data-row">
        <span class="data-col data-values">{{'FILE_TYPE' | translate}}</span>
        <span *ngIf="protectedExtensions.length > 0; else noProtectedExtensions" class="data-col data-values">{{ protectedExtensions.join(', ') }}</span>
        <ng-template #noProtectedExtensions>
          <span class="data-col data-values">({{'NONE' | translate}})</span>
          <span></span>
        </ng-template>
        <span *ngIf="protectedExtensions.length > 0" id="copyProtectedExtensionsButton" class="mdi mdi-content-copy clickable copy-icon"
          matTooltip="{{'data-protections.copy-text-tooltip' | translate}}" matTooltipPosition="above"
          (click)="onCopyText(protectedExtensions.join(','))">
        </span>
      </div>
      <div class="data-row">
        <span class="data-col data-values">{{'FOLDER' | translate}}</span>
        <span *ngIf="protectedFolders.length > 0; else noProtectedFolders" class="data-col data-values">{{ protectedFolders.join(', ') }}</span>
        <ng-template #noProtectedFolders>
          <span class="data-col data-values">({{'NONE' | translate}})</span>
          <span></span>
        </ng-template>
        <span *ngIf="protectedFolders.length > 0" id="copyProtectedFoldersButton" class="mdi mdi-content-copy clickable copy-icon"
          matTooltip="{{'data-protections.copy-text-tooltip' | translate}}" matTooltipPosition="above"
          (click)="onCopyText(protectedFolders.join(','))">
        </span>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<mat-card appearance="raised">
  <mat-card-header>
    <mat-card-title>
      <span class="mdi mdi-lock-outline title-icon"></span>{{'data-protections.secure-vaults' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div *ngIf="secureVaultVolumes.length > 0; else noSecureVaults" class="file-section-wrapper">
      <div class="header-row">
        <span class="header-col">{{'data-protections.drive' | translate}}</span>
        <span class="header-col">{{'data-protections.protection' | translate}}</span>
      </div>
      <div *ngFor="let volume of secureVaultVolumes; let i=index;" class="data-row">
        <span class="data-col data-values">{{ volume.mount }}:</span>
        <span class="data-col data-values">{{ volume.protectionMode }}</span>
        <span *ngIf="volume" id="copyCigentSecureSSDVolumeButton-{{i}}" class="mdi mdi-content-copy clickable copy-icon"
          matTooltip="{{'data-protections.copy-text-tooltip' | translate}}" matTooltipPosition="above"
          (click)="onCopyText(volume.protectionMode)">
        </span>
      </div>
    </div>
    <ng-template #noSecureVaults>
      <div class="file-section-wrapper">
        <div class="data-col no-data-values">{{'data-protections.no-secure-drives-found' | translate}}</div>
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>

<mat-card appearance="raised">
  <mat-card-header>
    <mat-card-title>
      <span class="mdi mdi-zip-box-outline title-icon"></span>{{'data-protections.encryption' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="data-title">{{'FOLDER' | translate}}</div>
      <div *ngIf="encryptedFolders.length > 0; else noEncryptionFolders" class="file-section-wrapper">
        <div class="header-row">
          <span class="header-col">{{'provision-template.protection-mode-text' | translate}}</span>
          <span class="header-col">{{'data-protections.folder-encryption-keys' | translate}}</span>
        </div>
        <div *ngFor="let folder of encryptedFolders; let i=index;" class="data-row">
          <span class="data-col data-values">{{ folder.protectionMode }}</span>
          <span class="data-col data-values">{{ folder.directoryWithKeys }}</span>
          <span id="copyEncryptionButton-{{i}}" class="mdi mdi-content-copy clickable copy-icon"
            matTooltip="{{'data-protections.copy-text-tooltip' | translate}}" matTooltipPosition="above"
            (click)="onCopyText(folder.directoryWithKeys)">
          </span>
        </div>
      </div>
      <ng-template #noEncryptionFolders>
        <div class="file-section-wrapper">
          <div class="data-col no-data-values">{{'data-protections.no-data-found' | translate}}</div>
        </div>
      </ng-template>

    <div class="data-title">{{'data-protections.full-drive' | translate}}</div>
      <div *ngIf="(hasEncryptionMounts || hasPBA) else noFullDriveInfo" class="file-section-wrapper">
        <div class="header-row">
          <span class="header-col">{{'TYPE' | translate}}</span>
          <span class="header-col">{{'VALUE' | translate}}</span>
        </div>
        <div *ngFor="let mount of encryptionMounts | keyvalue" class="data-row">
          <span class="data-col data-values">{{ mount.key }}</span>
          <span class="data-col data-values">{{ mount.value.join(', ') }}</span>
          <span class="mdi mdi-content-copy clickable copy-icon"
            matTooltip="{{'data-protections.copy-text-tooltip' | translate}}" matTooltipPosition="above"
            (click)="onCopyText(mount.value.join(','))">
          </span>
        </div>
        <div *ngIf="hasPBA" class="data-row">
          <span class="data-col data-values">{{'data-protections.cigent-pba' | translate}}</span>
          <span class="data-col data-values">{{'ENABLED' | translate}}</span>
          <span></span>
        </div>
      </div>
    <ng-template #noFullDriveInfo>
      <div class="file-section-wrapper">
        <div class="data-col no-data-values">{{'data-protections.no-data-found' | translate}}</div>
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>